import React, { Component } from 'react';
import './VideosHome.css';
import VideosRow from './VideosRow';
import DummyVideoRow from './DummyVideoRow';
import BondingCurveAccordion from './BondingCurveAccordion';
import RecentLivestreams from './RecentLivestreams';
import UpcomingLivestreams from './UpcomingLivestreams';
import LatestLivestream from './LatestLivestream';
import HighlightedLivestream from './HighlightedLivestream';
import PreviousLivestreams from './PreviousLivestreams';
import logo from './logo.png';
import { CgSpinner } from "react-icons/cg";

class VideosHome extends Component {
  constructor(props) {
    super(props);
  // TODO lots of hard coded data to keep up to date
  this.state = {
    latestLivestream: {
      "creatorAddress": "0x7933231775dec3f3c80039debd7e3afd8a81f674",
      "creatorImage": "https://pbs.twimg.com/profile_banners/3304027585/1652511739/1500x500",
      "creatorName": "UVR",
      "itemName": "GATED AND UNCUT",
      "itemRoute": "/profile/uvr",
      "video": "https://ppv-nft-files.s3.us-west-2.amazonaws.com/QmZD5AfQEAjFX5mAxWuDuv8r2LLfT6jTqULXgdgY8Q4uj2.mp4"
    }
  }
}
  render() {
    return (
      <div className="w-screen justify-center flex flex-col">
        <HighlightedLivestream />
        <PreviousLivestreams
          address={this.props.address}
          creatorAddress={this.state.latestLivestream.creatorAddress}
          creatorImage={this.state.latestLivestream.creatorImage}
          creatorName={this.state.latestLivestream.creatorName}
          video={this.state.latestLivestream.video}
          itemName={this.state.latestLivestream.itemName}
          itemRoute={this.state.latestLivestream.itemRoute}
          selectItemForSubscribe={this.props.selectItemForSubscribe}
          subscriberStatuses={this.props.subscriberStatuses}
        />
        <UpcomingLivestreams
          address={this.props.address}
          selectItemForSubscribe={this.props.selectItemForSubscribe}
          subscriberStatuses={this.props.subscriberStatuses}
        />
        <div class="flex h-32">

        </div>
      </div>
    );
  }
}

export default VideosHome;
